import { Reducer } from 'redux';
import { Action } from 'Store/types';

export enum ActionTypes {
  GET_QUESTIONS = '@questions/GET',
}
export type Questions = any[];

export type QuestionsReducer = Reducer<Questions, Action<ActionTypes>>;
